webpackJsonp([256810187883326],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dna/Documents/WebProjects/DanIsacson/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dna/Documents/WebProjects/DanIsacson/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dna/Documents/WebProjects/DanIsacson/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/dna/Documents/WebProjects/DanIsacson/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dna/Documents/WebProjects/DanIsacson/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dna/Documents/WebProjects/DanIsacson/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/portfolio.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var linkStyle = {
	  color: _colors2.default.dnaDark
	};
	
	var PortfolioPage = function (_Component) {
	  _inherits(PortfolioPage, _Component);
	
	  function PortfolioPage() {
	    _classCallCheck(this, PortfolioPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PortfolioPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        { title: "Dan Isacson - Portfolio" },
	        _react2.default.createElement('meta', { name: 'description', content: 'Dan Isacson\'s portfolio' })
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Portfolio'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Portfolio will be here! But for now I\'ll list some of the clients I\'ve worked with: ',
	        _react2.default.createElement(
	          'a',
	          { style: linkStyle, href: 'https://www.absolut.com/se/', target: '_blank' },
	          'Absolut'
	        ),
	        ', ',
	        _react2.default.createElement(
	          'a',
	          { style: linkStyle, href: 'http://www.vasaloppet.se/', target: '_blank' },
	          'Vasaloppet'
	        ),
	        ', ',
	        _react2.default.createElement(
	          'a',
	          { style: linkStyle, href: 'https://www.betsson.com/en/', target: '_blank' },
	          'Betsson'
	        ),
	        ', ',
	        _react2.default.createElement(
	          'a',
	          { style: linkStyle, href: 'https://www.bethard.com/', target: '_blank' },
	          'Bethard'
	        ),
	        ', ',
	        _react2.default.createElement(
	          'a',
	          { style: linkStyle, href: 'https://www.betsafe.com/', target: '_blank' },
	          'Betsafe'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'My master thesis that I wrote about smartwatch application development (written when the Apple Watch was released) can be found ',
	        _react2.default.createElement(
	          'a',
	          { style: linkStyle, href: 'http://www.diva-portal.org/smash/record.jsf?pid=diva2%3A826851&dswid=2451', target: '_blank' },
	          'here'
	        ),
	        '.'
	      )
	    );
	  };
	
	  return PortfolioPage;
	}(_react.Component);
	
	exports.default = PortfolioPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portfolio-jsx-06f835ebbd1d9f489401.js